export default __webpack_public_path__ + "static/Nessie_Koer-256f54361c98e7d55a831312a971c4f1.png";